import { Field } from 'formik';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AiOutlineCalendar } from 'react-icons/ai';

interface IProps {
  label?: string;
  id?: string;
  name?: string;
  className?: string;
  showTime?: boolean;
}

const FormikDatepicker: React.FC<IProps> = ({
  label,
  id,
  name,
  className = '',
  showTime = false,
}) => {
  return (
    <div className="w-full relative mr-4 flex flex-col bg-primary-15 rounded mb-2">
      {label && (
        <label htmlFor={id} className="text-sm">
          {label}
        </label>
      )}

      <Field name={name}>
        {({ field, form }: { field: any; form: any }) => (
          <ReactDatePicker
            id={id}
            {...field}
            selected={field.value}
            onChange={(date) => form.setFieldValue(name, date)}
            showTimeInput={showTime}
            dateFormat={showTime ? 'MMM d, yyyy h:mm aa' : 'MMM d, yyyy'}
            showMonthDropdown
            showYearDropdown
            scrollableYearDropdown
            className={`w-full mt-2 appearance-none text-text-black placeholder:capitalize rounded py-3 block placeholder:text-sm px-3 bg-pure-white text-sm ring-1 ring-light-grey focus:ring-primary focus:outline-0 ${className}`}
            placeholderText="Select date"
            onCalendarClose={() => form.setFieldTouched(name, true)}
          />
        )}
      </Field>

      <div className="absolute right-2 top-9">
        <AiOutlineCalendar size={24} className="text-gray-400" />
      </div>
    </div>
  );
};

export default FormikDatepicker;
